// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/approval_flow_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { BusinessProcess, PlanningSection } from "../../bfftypes/v1/approval_flow_type_pb";
import { file_bfftypes_v1_approval_flow_type } from "../../bfftypes/v1/approval_flow_type_pb";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { ApprovalFlowCell, ApprovalFlowProcessSetting, ApproverCandidate, AutoBidRule, AutoSwitchCondition, SwitchHistoryEntry } from "./approval_flow_model_pb";
import { file_bffuser_v1_approval_flow_model } from "./approval_flow_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/approval_flow_service.proto.
 */
export const file_bffuser_v1_approval_flow_service: GenFile = /*@__PURE__*/
  fileDesc("CiZiZmZ1c2VyL3YxL2FwcHJvdmFsX2Zsb3dfc2VydmljZS5wcm90bxIKYmZmdXNlci52MSIeChxHZXRBcHByb3ZhbEZsb3dTY3JlZW5SZXF1ZXN0Io0BCh1HZXRBcHByb3ZhbEZsb3dTY3JlZW5SZXNwb25zZRI5Cglwcm9jZXNzZXMYASADKAsyJi5iZmZ1c2VyLnYxLkFwcHJvdmFsRmxvd1Byb2Nlc3NTZXR0aW5nEjEKCmNhbmRpZGF0ZXMYAiADKAsyHS5iZmZ1c2VyLnYxLkFwcHJvdmVyQ2FuZGlkYXRlIvgBChdTYXZlQXBwcm92YWxGbG93UmVxdWVzdBJCChBidXNpbmVzc19wcm9jZXNzGAEgASgOMhwuYmZmdHlwZXMudjEuQnVzaW5lc3NQcm9jZXNzQgq6SAeCAQQQASAAEisKBWNlbGxzGAIgAygLMhwuYmZmdXNlci52MS5BcHByb3ZhbEZsb3dDZWxsEjMKCmNvbmRpdGlvbnMYAyADKAsyHy5iZmZ1c2VyLnYxLkF1dG9Td2l0Y2hDb25kaXRpb24SNwoTZXhwZWN0ZWRfdXBkYXRlZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiSgoYU2F2ZUFwcHJvdmFsRmxvd1Jlc3BvbnNlEi4KCnVwZGF0ZWRfYXQYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIqgBCiRMaXN0QXBwcm92YWxNb2RlU3dpdGNoSGlzdG9yeVJlcXVlc3QSQAoQYnVzaW5lc3NfcHJvY2VzcxgBIAEoDjIcLmJmZnR5cGVzLnYxLkJ1c2luZXNzUHJvY2Vzc0IIukgFggECEAESMgoHc2VjdGlvbhgCIAEoDjIcLmJmZnR5cGVzLnYxLlBsYW5uaW5nU2VjdGlvbkgAiAEBQgoKCF9zZWN0aW9uIlgKJUxpc3RBcHByb3ZhbE1vZGVTd2l0Y2hIaXN0b3J5UmVzcG9uc2USLwoHZW50cmllcxgBIAMoCzIeLmJmZnVzZXIudjEuU3dpdGNoSGlzdG9yeUVudHJ5IoECChZTYXZlQXV0b0JpZFJ1bGVSZXF1ZXN0EkIKEGJ1c2luZXNzX3Byb2Nlc3MYASABKA4yHC5iZmZ0eXBlcy52MS5CdXNpbmVzc1Byb2Nlc3NCCrpIB4IBBBABIAASPAoKYXJlYV9jb2RlcxgCIAMoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlQhG6SA6SAQsIASIHggEEEAEgABIxCghidXlfcnVsZRgDIAEoCzIXLmJmZnVzZXIudjEuQXV0b0JpZFJ1bGVCBrpIA8gBARIyCglzZWxsX3J1bGUYBCABKAsyFy5iZmZ1c2VyLnYxLkF1dG9CaWRSdWxlQga6SAPIAQEiQQoXU2F2ZUF1dG9CaWRSdWxlUmVzcG9uc2USJgoFcnVsZXMYASADKAsyFy5iZmZ1c2VyLnYxLkF1dG9CaWRSdWxlMs0DChNBcHByb3ZhbEZsb3dTZXJ2aWNlEm4KFUdldEFwcHJvdmFsRmxvd1NjcmVlbhIoLmJmZnVzZXIudjEuR2V0QXBwcm92YWxGbG93U2NyZWVuUmVxdWVzdBopLmJmZnVzZXIudjEuR2V0QXBwcm92YWxGbG93U2NyZWVuUmVzcG9uc2UiABJfChBTYXZlQXBwcm92YWxGbG93EiMuYmZmdXNlci52MS5TYXZlQXBwcm92YWxGbG93UmVxdWVzdBokLmJmZnVzZXIudjEuU2F2ZUFwcHJvdmFsRmxvd1Jlc3BvbnNlIgAShgEKHUxpc3RBcHByb3ZhbE1vZGVTd2l0Y2hIaXN0b3J5EjAuYmZmdXNlci52MS5MaXN0QXBwcm92YWxNb2RlU3dpdGNoSGlzdG9yeVJlcXVlc3QaMS5iZmZ1c2VyLnYxLkxpc3RBcHByb3ZhbE1vZGVTd2l0Y2hIaXN0b3J5UmVzcG9uc2UiABJcCg9TYXZlQXV0b0JpZFJ1bGUSIi5iZmZ1c2VyLnYxLlNhdmVBdXRvQmlkUnVsZVJlcXVlc3QaIy5iZmZ1c2VyLnYxLlNhdmVBdXRvQmlkUnVsZVJlc3BvbnNlIgBCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bfftypes_v1_approval_flow_type, file_bfftypes_v1_area, file_bffuser_v1_approval_flow_model, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * @generated from message bffuser.v1.GetApprovalFlowScreenRequest
 */
export type GetApprovalFlowScreenRequest = Message<"bffuser.v1.GetApprovalFlowScreenRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetApprovalFlowScreenRequest.
 * Use `create(GetApprovalFlowScreenRequestSchema)` to create a new message.
 */
export const GetApprovalFlowScreenRequestSchema: GenMessage<GetApprovalFlowScreenRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_service, 0);

/**
 * @generated from message bffuser.v1.GetApprovalFlowScreenResponse
 */
export type GetApprovalFlowScreenResponse = Message<"bffuser.v1.GetApprovalFlowScreenResponse"> & {
  /**
   * processes is the per-business-process approval-flow configuration.
   *
   * @generated from field: repeated bffuser.v1.ApprovalFlowProcessSetting processes = 1;
   */
  processes: ApprovalFlowProcessSetting[];

  /**
   * candidates lists the members eligible to be designated as approvers,
   * used by the screen to resolve approver member ids to display names and
   * to populate the approver picker.
   *
   * @generated from field: repeated bffuser.v1.ApproverCandidate candidates = 2;
   */
  candidates: ApproverCandidate[];
};

/**
 * Describes the message bffuser.v1.GetApprovalFlowScreenResponse.
 * Use `create(GetApprovalFlowScreenResponseSchema)` to create a new message.
 */
export const GetApprovalFlowScreenResponseSchema: GenMessage<GetApprovalFlowScreenResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_service, 1);

/**
 * @generated from message bffuser.v1.SaveApprovalFlowRequest
 */
export type SaveApprovalFlowRequest = Message<"bffuser.v1.SaveApprovalFlowRequest"> & {
  /**
   * @generated from field: bfftypes.v1.BusinessProcess business_process = 1;
   */
  businessProcess: BusinessProcess;

  /**
   * @generated from field: repeated bffuser.v1.ApprovalFlowCell cells = 2;
   */
  cells: ApprovalFlowCell[];

  /**
   * @generated from field: repeated bffuser.v1.AutoSwitchCondition conditions = 3;
   */
  conditions: AutoSwitchCondition[];

  /**
   * expected_updated_at must match the server-side updated_at for the given
   * business process (optimistic lock). It is intentionally NOT required:
   * an absent (nil) value expresses a first-time create for an organization
   * that has no saved configuration yet. The backend usecase treats nil as
   * "create" and rejects a present-but-zero value with InvalidArgument.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 4;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SaveApprovalFlowRequest.
 * Use `create(SaveApprovalFlowRequestSchema)` to create a new message.
 */
export const SaveApprovalFlowRequestSchema: GenMessage<SaveApprovalFlowRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_service, 2);

/**
 * @generated from message bffuser.v1.SaveApprovalFlowResponse
 */
export type SaveApprovalFlowResponse = Message<"bffuser.v1.SaveApprovalFlowResponse"> & {
  /**
   * updated_at is the new server-side timestamp after the save.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SaveApprovalFlowResponse.
 * Use `create(SaveApprovalFlowResponseSchema)` to create a new message.
 */
export const SaveApprovalFlowResponseSchema: GenMessage<SaveApprovalFlowResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_service, 3);

/**
 * @generated from message bffuser.v1.ListApprovalModeSwitchHistoryRequest
 */
export type ListApprovalModeSwitchHistoryRequest = Message<"bffuser.v1.ListApprovalModeSwitchHistoryRequest"> & {
  /**
   * @generated from field: bfftypes.v1.BusinessProcess business_process = 1;
   */
  businessProcess: BusinessProcess;

  /**
   * section is optional; absent means all sections.
   *
   * @generated from field: optional bfftypes.v1.PlanningSection section = 2;
   */
  section?: PlanningSection;
};

/**
 * Describes the message bffuser.v1.ListApprovalModeSwitchHistoryRequest.
 * Use `create(ListApprovalModeSwitchHistoryRequestSchema)` to create a new message.
 */
export const ListApprovalModeSwitchHistoryRequestSchema: GenMessage<ListApprovalModeSwitchHistoryRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_service, 4);

/**
 * @generated from message bffuser.v1.ListApprovalModeSwitchHistoryResponse
 */
export type ListApprovalModeSwitchHistoryResponse = Message<"bffuser.v1.ListApprovalModeSwitchHistoryResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.SwitchHistoryEntry entries = 1;
   */
  entries: SwitchHistoryEntry[];
};

/**
 * Describes the message bffuser.v1.ListApprovalModeSwitchHistoryResponse.
 * Use `create(ListApprovalModeSwitchHistoryResponseSchema)` to create a new message.
 */
export const ListApprovalModeSwitchHistoryResponseSchema: GenMessage<ListApprovalModeSwitchHistoryResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_service, 5);

/**
 * @generated from message bffuser.v1.SaveAutoBidRuleRequest
 */
export type SaveAutoBidRuleRequest = Message<"bffuser.v1.SaveAutoBidRuleRequest"> & {
  /**
   * @generated from field: bfftypes.v1.BusinessProcess business_process = 1;
   */
  businessProcess: BusinessProcess;

  /**
   * area_codes: the areas to write. Single-area edit sends one area code;
   * bulk edit sends every currently-自動(AUTO) area with identical values.
   *
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 2;
   */
  areaCodes: AreaCode[];

  /**
   * @generated from field: bffuser.v1.AutoBidRule buy_rule = 3;
   */
  buyRule?: AutoBidRule;

  /**
   * @generated from field: bffuser.v1.AutoBidRule sell_rule = 4;
   */
  sellRule?: AutoBidRule;
};

/**
 * Describes the message bffuser.v1.SaveAutoBidRuleRequest.
 * Use `create(SaveAutoBidRuleRequestSchema)` to create a new message.
 */
export const SaveAutoBidRuleRequestSchema: GenMessage<SaveAutoBidRuleRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_service, 6);

/**
 * @generated from message bffuser.v1.SaveAutoBidRuleResponse
 */
export type SaveAutoBidRuleResponse = Message<"bffuser.v1.SaveAutoBidRuleResponse"> & {
  /**
   * rules is the full persisted set for the affected areas (buy + sell each).
   *
   * @generated from field: repeated bffuser.v1.AutoBidRule rules = 1;
   */
  rules: AutoBidRule[];
};

/**
 * Describes the message bffuser.v1.SaveAutoBidRuleResponse.
 * Use `create(SaveAutoBidRuleResponseSchema)` to create a new message.
 */
export const SaveAutoBidRuleResponseSchema: GenMessage<SaveAutoBidRuleResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_flow_service, 7);

/**
 * ApprovalFlowService provides Connect RPCs for managing approval flow
 * settings per business process.
 *
 * @generated from service bffuser.v1.ApprovalFlowService
 */
export const ApprovalFlowService: GenService<{
  /**
   * GetApprovalFlowScreen returns everything the approval-flow admin screen
   * needs in one call: the per-process configuration plus the directory of
   * members that can be designated as approvers. This is a read-only BFF
   * aggregation: it fans out to the backend
   * ApprovalFlowService.GetApprovalFlowSettings and
   * UserDirectoryService.ListMembers and shapes the result for the screen.
   *
   * @generated from rpc bffuser.v1.ApprovalFlowService.GetApprovalFlowScreen
   */
  getApprovalFlowScreen: {
    methodKind: "unary";
    input: typeof GetApprovalFlowScreenRequestSchema;
    output: typeof GetApprovalFlowScreenResponseSchema;
  },
  /**
   * SaveApprovalFlow overwrites the approval-flow configuration for one
   * business process. Uses optimistic locking via expected_updated_at.
   *
   * @generated from rpc bffuser.v1.ApprovalFlowService.SaveApprovalFlow
   */
  saveApprovalFlow: {
    methodKind: "unary";
    input: typeof SaveApprovalFlowRequestSchema;
    output: typeof SaveApprovalFlowResponseSchema;
  },
  /**
   * ListApprovalModeSwitchHistory returns the history of automatic
   * approval-mode switches for the given business process.
   *
   * @generated from rpc bffuser.v1.ApprovalFlowService.ListApprovalModeSwitchHistory
   */
  listApprovalModeSwitchHistory: {
    methodKind: "unary";
    input: typeof ListApprovalModeSwitchHistoryRequestSchema;
    output: typeof ListApprovalModeSwitchHistoryResponseSchema;
  },
  /**
   * SaveAutoBidRule persists the buy/sell 自動入札ルール pair to every area
   * in area_codes (upsert, last-write-wins). A single area_codes entry is a
   * per-area edit (AC-02); multiple entries are a 全エリア一括編集 (AC-03).
   *
   * @generated from rpc bffuser.v1.ApprovalFlowService.SaveAutoBidRule
   */
  saveAutoBidRule: {
    methodKind: "unary";
    input: typeof SaveAutoBidRuleRequestSchema;
    output: typeof SaveAutoBidRuleResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_approval_flow_service, 0);

